// Mirrors the controller's PER_PAGE; only a fallback - the index meta.perPage
// overrides it as soon as the first page lands.
export const LIKERS_PER_PAGE = 20
